import { cn } from './cn';

interface Props {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string | undefined;
}

const SIZES = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
} as const;

export function Spinner({ size = 'md', className, label = 'Loading' }: Props): JSX.Element {
  return (
    <span role="status" aria-live="polite" className={cn('inline-flex', className)}>
      <span className="sr-only">{label}</span>
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        className={cn('animate-spin text-primary', SIZES[size])}
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="4" />
        <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="4" />
      </svg>
    </span>
  );
}

export function FullPageSpinner({ label }: { label?: string }): JSX.Element {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <Spinner size="lg" label={label} />
    </div>
  );
}
